import React from 'react'
import styled from 'styled-components/macro'
import { textStyle, compose, space, MarginProps } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'
import DropdownItem from 'react-bootstrap/DropdownItem'
import { Link, LinkProps } from 'react-router-dom'
import { DropdownSVG } from '../../../Icons/Basic'
import palette from '../../../../designSystem/variables/palette'
import { NestedFilterChevron } from './FilterDropdowns/FilterDropdown.components'
import { DropdownMenuItemStyle } from './FilterDropdowns/FilterDropdown.styles'

export const FilterBarContainer = styled.ul.attrs({})<MarginProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0;
  padding: 0;
  min-height: 24px;
  ${compose(space)}
`

export const FilterSearchContainer = styled.ul<{ $isSearchExpanded: boolean }>`
  display: flex;
  gap: 8px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 8px 0;
  padding: 0;
  transition: all 0.6s ease;
  flex-wrap: nowrap;
`

export const FilterBarWrapper = styled.ul.attrs({})<MarginProps>`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  padding: 0;
  width: 100%;
  min-height: 24px;
  gap: 8px;
  transition: flex-grow 0.6s ease;
  ${compose(space)}
  margin: 0;
`

export const CompactFiltersTextButton = styled.button`
  background: none;
  border: none;
  margin: 0;
  padding: 0;
  cursor: pointer;
  color: ${palette.neutral[800]};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  white-space: nowrap;
  flex-shrink: 0;
  text-align: left;

  &:hover {
    text-decoration: underline;
  }
`

export const FilterDropdownToggleContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const FilterDropdownIcon = styled(DropdownSVG).attrs({
  className: 'filter-dropdown-icon',
})`
  width: 16px;
  height: 16px;
  color: ${palette.neutral[900]};
`

export const FilterDropdownToggle = styled.button.attrs<{
  $isNested?: boolean
}>((props) => {
  return {
    textStyle: 'body.default',
    children: (
      <>
        <FilterDropdownToggleContent>
          {props.children}
        </FilterDropdownToggleContent>
        {props.$isNested ? <NestedFilterChevron /> : <FilterDropdownIcon />}
      </>
    ),
  }
})<{ $isAi?: boolean; $hasSelection?: boolean; $isNested?: boolean }>`
  ${textStyle}

  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 24px;
  margin: 0;
  padding: 2px 8px 2px 12px;
  gap: 10px;
  border: ${({ $hasSelection }) =>
    $hasSelection
      ? `1px solid ${palette.neutral['200']}`
      : `1px solid ${palette.neutral['100']}`};
  border-radius: 20px;
  background-color: ${palette.neutral.white};
  color: ${({ $hasSelection }) =>
    $hasSelection ? palette.neutral.black : palette.neutral['500']};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  cursor: pointer;
  transition: transform 0.4s ease-in-out, opacity 0.4s ease-in-out;
  will-change: transform, opacity;

  &[aria-expanded='false'] {
    p {
      ${({ $isAi }) => $isAi && `color: ${palette.purple['600']}`}
    }
  }

  :hover {
    background-color: ${themeGet('colors.bg.neutral')};
  }

  &[aria-expanded='true'] {
    background-color: ${palette.neutral['500']};
    color: ${palette.neutral.white};
    svg:not(.filter-dropdown-icon) {
      path {
        fill: ${palette.neutral.white};
      }
    }
    .filter-dropdown-icon {
      transform: scaleY(-1);
      fill: ${palette.neutral.white};
    }
  }

  .filter-dropdown-icon {
    transform: scaleY(1);
    transition: transform 0.35s;
    fill: ${palette.neutral['400']};
  }

  :after {
    display: none;
  }
`

export const FilterDropdownItem = styled(DropdownItem).attrs({
  as: Link,
})<LinkProps>`
  display: flex;
  align-items: center;
  text-decoration: none;

  ${DropdownMenuItemStyle}

  .form-check {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 6px 16px !important;

    .form-check-input {
      width: 14px;
      height: 14px;
    }
  }
`
